/**
 *
 * @author: Matthew Rawson @ 26/06/2018 08:41
 * @description:
 * @notes:
 */
import styled from "styled-components"

import {SectionPosRel} from "@irati/ui/src/Layout/Section"
import padding from "@irati/ui/src/global/padding"


const Page = styled(SectionPosRel)`
  padding-top: ${padding.tiny};
`

export default Page
